import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApplications } from './useApplications';

export function useRedirectToFirstApp(shouldRedirect = true) {
  const navigate = useNavigate();
  const location = useLocation();
  const { apps, loading } = useApplications();

  const redirectApp =
    !loading && shouldRedirect && apps.length > 0 ? apps[0] : undefined;

  const isRedirecting = !!redirectApp;

  useEffect(() => {
    if (!redirectApp) return;
    navigate(
      { pathname: `/${redirectApp.slug}`, search: location.search },
      { replace: true }
    );
  }, [redirectApp, navigate, location.search]);

  return { apps, loading, isRedirecting };
}
